import type { useDraftStore } from '../stores/draft.store';
import type { useEvidenceStore } from '../stores/evidence.store';

/**
 * Reverts a single evidence item back to the original transcript-extracted value.
 * Called when the user discards an in-progress edit on a specific item.
 */
export function revertEvidenceItem(
  itemId: string,
  draftStore: ReturnType<typeof useDraftStore>,
  evidenceStore: ReturnType<typeof useEvidenceStore>,
): void {

  const originalValue = draftStore.originalExtraction[itemId] ?? null;
  evidenceStore.updateEvidenceValue({ itemId, value: String(originalValue ?? '') });
}
